import ajaxRequest from './ajax'
import qs from "qs"

//  添加观看记录
export const add_vod_watch_duration = params => {
    return ajaxRequest.post('/vodWatchDuration/add_vod_watch_duration',params);
}


export const get_vod_watch_duration = params => {
    return ajaxRequest.post('/vodWatchDuration/get_vod_watch_duration',params);
}





// WEBPACK FOOTER //
// ./src/api/vodWatchDuration.js